import Mustache from "mustache";

export class MustacheHelper {
    static evaluate(template: string, data = {}) {
        try {
            const renderedTemplate = Mustache.render(template, data);
            console.log("@rendered expr : ", renderedTemplate);
            return eval(renderedTemplate);
            // return 0
        } catch (error) {
            // console.log("@evaluation expr :", error)
            return 0
        }
    }
}